import { Users } from '@just-in-types';
import store from '..';

export const SET_ROUTES = 'router.SET_ROUTES';
export const setRoutes = (user: Users.User | Users.UserWithAccount) => {
  const adminRoutes = [
    'businesses',
    'check-ins',
    'users',
    'inventory',
    'notifications',
    'reports',
  ];
  const defaultRoutes = ['check-ins'];
  const ownerRoutes = ['reports', ...defaultRoutes];

  if ('accountData' in user) {
    const {
      permissions: { role },
    } = user.accountData;

    return store.dispatch({
      payload:
        role === 'admin'
          ? adminRoutes
          : role === 'owner'
            ? ownerRoutes
            : defaultRoutes,
      type: SET_ROUTES,
    });
  } else {
    return store.dispatch({ payload: defaultRoutes, type: SET_ROUTES });
  }
};



// WEBPACK FOOTER //
// ./src/store/actions/routerActions.ts